<template>
    <div id="app">
        <v-app id="inspire">
            <v-card v-model="show" color="#FFFF99">
                <v-card-title>
                    <v-icon large left>mdi-wrench-clock</v-icon>
                    <h6>Listado de Adjudicaciones</h6>
                </v-card-title>
                <v-card-text class="pt-2">
                    <v-row dense>
                        <v-col cols="6" sm="6" md="1">
                            <v-select item-color="green" color="green darken-2" dense v-model="filtromes"
                                :items="listadomes" label="Mes" item-text="nombre" item-value="codigo"></v-select>
                        </v-col>
                        <v-col cols="6" sm="6" md="1">
                            <v-text-field label="Filtro por Año" dense v-model="filtroanio">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6" sm="6" md="2">
                            <v-text-field label="Filtro por Responsable" dense v-model="filtroresponsable">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6" sm="6" md="3">
                            <v-text-field label="Filtro por Empresa" dense v-model="filtrocliente">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6" sm="6" md="3">
                            <v-text-field label="Filtro por Obra" dense v-model="filtroobra">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6" sm="6" md="2">
                            <v-text-field label="Filtro por Factibilidad" dense v-model="filtrofact">
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row align="center" justify="space-around">
                        <v-btn tile color="success" @click="cargarListados()">
                            <v-icon left> mdi-magnify </v-icon>
                            Buscar
                        </v-btn>
                    </v-row>
                </v-card-text>
            </v-card>

            <v-data-table dense :headers="headers" :items="listado" group-by="numeroMes" locale="es-ar"
                class="elevation-1" :items-per-page="500" :footer-props="{
                    itemsPerPageText: 'equipos por página',
                }" :loading="loadtable" loading-text="Cargando... Espere por favor"
                no-data-text="No hay datos disponibles">
                <template v-slot:group.header="{ items }">
                    <td class="text-xs-right">
                        <strong>{{ items[0].mes }}</strong>
                    </td>
                </template>
                <template v-slot:item.precioporc="{ item }">
                    {{ mostrarprecio(item.moneda, item.precio, item.cotizac1, item.porcentaje) }}
                </template>
                <template v-slot:item.pesos="{ item }">
                    {{ mostrarpesos(item.moneda, item.precio, item.cotizac1, item.porcentaje) }}
                </template>
                <template v-slot:group.summary="{ group, items }">
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <td>
                        {{ subTotal(items, 'precio', 'cotizac1', 'moneda', 'porcentaje') }}
                    </td>
                    <td>
                        {{ subTotalPesos(items, 'precio', 'cotizac1', 'moneda', 'porcentaje') }}
                    </td>
                    <th></th>
                    <th></th>
                </template>
                <template slot="body.append">
                    <tr>
                        <th>TOTAL</th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th>U$S {{ ValorTotal() }}</th>
                        <th>$ {{ ValorTotalPesos() }}</th>
                    </tr>
                    <th></th>
                    <th></th>
                </template>
            </v-data-table>
        </v-app>
    </div>
</template>

<script>
import moment from 'moment';
import axios from "../../../axios-auth";


export default {

    data: (vm) => ({
        loadtable: false,
        filtroanio: moment().format("YYYY"),
        filtromes: "",
        filtroresponsable: "",
        filtrocliente: "",
        filtroobra: "",
        filtrofact: "",
        menu: false,
        modal: false,
        listado: [],
        listadomes: [
            { nombre: "TODOS", codigo: "" },
            { nombre: "ENERO", codigo: "01" },
            { nombre: "FEBRERO", codigo: "02" },
            { nombre: "MARZO", codigo: "03" },
            { nombre: "ABRIL", codigo: "04" },
            { nombre: "MAYO", codigo: "05" },
            { nombre: "JUNIO", codigo: "06" },
            { nombre: "JULIO", codigo: "07" },
            { nombre: "AGOSTO", codigo: "08" },
            { nombre: "SEPTIEMBRE", codigo: "09" },
            { nombre: "OCTUBRE", codigo: "10" },
            { nombre: "NOVIEMBRE", codigo: "11" },
            { nombre: "DICIEMBRE", codigo: "12" },
        ],
        headers: [
            {
                text: "Mes",
                align: "start",
                sortable: false,
                value: "numeroMes",
                width: "7%"
            },
            { text: "", value: "", width: "7%" },
            { text: "Responsable", value: "resp", width: "10%" },
            { text: "Obra", value: "descr", width: "25%" },
            { text: "Cliente", value: "empresa", width: "20%" },
            { text: "Factibilidad", value: "fact", width: "7%" },
            { text: "Moneda", value: "moneda", width: "5%" },
            { text: "Presupuesto en Dólares", value: "precioporc", width: "10%" },
            { text: "Presupuesto en Pesos", value: "pesos", width: "8%" },
            { text: "Cotizac. Dólar", value: "cotizac1", width: "8%" },
            { text: "Informe Lanzamiento", value: "actions", width: "5%" },

        ],
    }),

    computed: {
        show: {
            get() {

                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },

    methods: {

        parseNumber(numberStr) {
            // Primero, eliminamos todos los puntos que podrían ser separadores de miles
            let normalized = numberStr.replace(/\.(?=\d{3})/g, '');
            // Luego, reemplazamos la coma decimal por punto
            normalized = normalized.replace(',', '.');
            // Convertimos a número flotante
            return parseFloat(normalized);
        },

        formatNumber(number) {
            // Convertir el número a string
            let [integerPart, decimalPart] = number.toFixed(2).split('.');

            // Añadir separadores de miles
            integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

            // Unir la parte entera y decimal con una coma
            return `${integerPart},${decimalPart}`;
        },

        subTotal(items, column, column2, column3, column1) {
            // Calcular el subtotal
            // const total = items.reduce((sum, item) => {
            //     return sum + (this.parseNumber(item[column]) * (item[column1]) / 100);
            // }, 0);
            const total = items.reduce((sum, item) => {
                if (item[column3] == 'D') {
                    return sum + ((this.parseNumber(item[column]) * (item[column1]) / 100));
                }
                else {
                    return sum + (this.parseNumber(item[column]) / item[column2] * (item[column1]) / 100);
                }
            }, 0);
            // Formatear el subtotal
            return this.formatNumber(total);
        },

        subTotalPesos(items, column1, column2, column3, column4) {
            // Calcular el subtotal
            const total = items.reduce((sum, item) => {
                if (item[column3] == 'D') {
                    return sum + ((this.parseNumber(item[column1]) * (item[column4]) / 100) * item[column2]);
                }
                else {
                    return sum + (this.parseNumber(item[column1]) * (item[column4]) / 100);
                }
            }, 0);

            // Formatear el subtotal
            return this.formatNumber(total);
        },

        ValorTotal() {

            let total = 0;
            this.listado.forEach((element) => {
                if (element.moneda == 'D') {
                    total = total + ((this.parseNumber(element.precio) * (element.porcentaje) / 100));
                }
                else {
                    total = total + (this.parseNumber(element.precio) / element.cotizac1 * (element.porcentaje) / 100);
                }
            });

            return this.formatNumber(total);
        },

        ValorTotalPesos() {

            let total = 0;
            this.listado.forEach((element) => {
                if (element.moneda == 'D') {
                    total = total + ((this.parseNumber(element.precio) * (element.porcentaje) / 100) * element.cotizac1);
                }
                else {
                    total = total + (this.parseNumber(element.precio) * (element.porcentaje) / 100);
                }
            });

            // Formatear el subtotal
            return this.formatNumber(total);
        },


        mostrarpesos(moneda, precio, cotizac, porcentaje) {

            if (moneda == 'D') {
                const totald = this.parseNumber(precio) * cotizac * porcentaje / 100;
                return this.formatNumber(totald);
            }
            else {
                const totalp = this.parseNumber(precio) * porcentaje / 100;
                return this.formatNumber(totalp);
            }
        },

        mostrarprecio(moneda, precio, cotizac, porcentaje) {
            if (moneda == 'D') {
                const totald = this.parseNumber(precio) * porcentaje / 100;
                return this.formatNumber(totald);
            }
            else {
                const totalp = this.parseNumber(precio) / cotizac * porcentaje / 100;
                return this.formatNumber(totalp);
            }
            // const total = this.parseNumber(precio) * porcentaje / 100;
            // return this.formatNumber(total);
        },

        formatDate(date) {
            if (!date) return null;
            const [year, month] = date.split("-");
            return `${month}/${year}`;
        },

        cargarListados() {
            this.vaciarModels();
            this.loadtable = true;
            if (this.filtromes == null) {
                this.filtromes = "";
            }
            if (this.filtroanio == null) {
                this.filtroanio = "";
            }
            if (this.filtroresponsable == null) {
                this.filtroresponsable = "";
            }
            if (this.filtrocliente == null) {
                this.filtrocliente = "";
            }
            if (this.filtroobra == null) {
                this.filtroobra = "";
            }
            const mes = this.filtromes;
            const resp = this.filtroresponsable;
            const anio = this.filtroanio;
            const cliente = this.filtrocliente;
            const obra = this.filtroobra;
            const fact = this.filtrofact;

            let self = this;

            axios
                .get("/Comercial/ListadoAdjudicadas?", {
                    params: {

                        anio: anio,
                        mes: mes,
                        resp: resp,
                        cliente: cliente,
                        obra: obra,
                        fact: fact,
                    },
                })
                .then((response) => {
                    self.listado = response.data;
                    self.loadtable = false;
                })
                .catch((error) => {
                    self.listado = [];
                    console.log(error);
                });
        },

        vaciarModels() {
            this.listado = [];
        },
    },
};
</script>